import cn from "classnames";
import { Transition } from "components/shared/column";
import { Select } from "components/shared/form";
import InlineBtn from "components/shared/inlineBtn";
import List from "components/shared/list";
import ScrollPositionContext from "contexts/scrollPosition";
import { paths } from "helpers/paths";
import { mergeFilters } from "helpers/reqparams";
import React, { Component } from "react";

export default class BookIndex extends Component {
    static contextType = ScrollPositionContext;
    state = { tableColumns: this.tableColumns };

    get selectOptions() {
        return { name: "test", options: [] };
    }

    renderCreateButton = () => {
        const { history, match, createBtnText, onlyRoot } = this.props;
        const { isRoot } = this.props.roles;
        if (!isRoot && onlyRoot) {
            return null;
        }
        const props = {
            className: "btn btn-brand btn-sm",
            onClick: () => history.push(`${match.path}/new`),
        };
        return !!createBtnText && <div {...props}>{createBtnText}</div>;
    };

    renderCounter = () => {
        const { count, params } = this.props;
        const { start, length } = params;
        return (
            <>
                &nbsp;
                <small>
                    (Отображены&nbsp;
                    <strong>
                        {count === 0 ? 0 : start + 1}-{start + length > count ? count : start + length}
                    </strong>
                    &nbsp;из <strong>{count}</strong>)
                </small>
            </>
        );
    };

    renderHead = () => {
        return (
            <div className="book-list__head-wrap">
                <div className="book-list__head">
                    <div className="book-list__head-close close close--sm" onClick={this.close} />
                    <div className="book-list__head-title">
                        {this.props.title}
                        {this.renderCounter()}
                    </div>
                    <div className="btn-toolbar">
                        {(this.props.canEditBooks || this.props.canCreateBooks) && this.renderCreateButton()}
                    </div>
                </div>
            </div>
        );
    };

    renderFilters = () => {
        const { name, options } = this.selectOptions;
        const filter = this.props.params.filters.find((item) => item.dataIndex === name);
        const value = filter && (filter.value || filter.value === 0) ? filter.value : "-";
        return (
            <div className="container-fluid my-2">
                <Select
                    options={[{ label: "Нет параметров", value: "-" }, ...options]}
                    onChange={this.mergeFilters}
                    inputProps={{ name }}
                    value={value}
                    unclearable
                />
            </div>
        );
    };

    mergeFilters = ({ name, value }) => {
        const { mergeParams, params } = this.props;
        mergeFilters(mergeParams, { name, value }, params);
    };

    renderActions() {
        const { mergeParams } = this.props;
        const actions = [{ value: "Обновить", cname: "refresh", active: true, action: mergeParams, params: {} }];
        return actions.map((item, index) => <InlineBtn key={index} {...item} />);
    }

    renderTableRow = () => {
        return null;
    };

    renderListComponent = () => {
        const { isTable } = this.props;
        return <List {...this.props} isTable={!!isTable} renderRow={this.renderTableRow} renderHead={this.thead} />;
    };

    thead = () => {
        return null;
    };

    close = () => {
        const { history, back } = this.props;
        back ? back() : history.push(paths.root);
    };

    restore = (id) => {
        this.props.modal({
            name: "confirm",
            title: "Вы действительно хотите восстановить?",
            action: () => this.props.source.restore({ id }).then(() => this.props.mergeParams({})),
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    };

    render() {
        const { nofilter, listRoute, transition } = this.props;
        const cname = cn("page-book__list book-list list", { "book-list--nofilter": !!nofilter });
        return (
            <Transition dir={transition || "left"} {...listRoute}>
                <div className={cname}>
                    {this.renderHead()}
                    {nofilter ? null : this.renderFilters()}
                    <div className="container-fluid my-2">{this.renderActions()}</div>
                    {this.renderListComponent()}
                </div>
            </Transition>
        );
    }
}
